import React from "react";
import { Route, Switch } from "react-router-dom";
import ProjectUsersPage from "../pages/ProjectUsersPage";
import SamplesPage from "../pages/SamplesPage";
import UserProjectsPage from "../pages/UserProjectsPage";
import NoProjectsPage from "../pages/NoProjectsPage";
import ProjectDocumentsPage from "../pages/ProjectDocumentsPage";
import TracerVisionPage from "../pages/TracerVisionPage";
import ProjectVideosPage from "../pages/ProjectVideosPage";
import LoginPage from "../pages/LoginPage";
import ProtectedRoute from "./ProtectedRoute";
import CommentTestPage from "../pages/CommentTestPage";
import ProjectOverviewPage from "../pages/ProjectOverviewPage";
import NotificationsPage from "../pages/NotificationsPage";
import PreferencesPage from "../pages/Preferences";
import ProfilePage from "../pages/ProfilePage";
import SurveyPage from "../pages/SurveyPage";
import ApiAccessPage from "../pages/ApiAccess";

export const ROUTE_PATH_HOME = "/";
export const ROUTE_PATH_PROJECTS = "/projects";
export const ROUTE_PATH_PROJECT_OVERVIEW = "/projects/:projectId";
export const ROUTE_PATH_PROJECT_USERS = "/projects/:projectId/users";
export const ROUTE_PATH_PROJECT_DOCUMENTS = "/projects/:projectId/documents";
export const ROUTE_PATH_PROJECT_VIDEOS =
    "/projects/:projectId/4d-visualisations";
export const ROUTE_PATH_PROJECT_SAMPLES = "/projects/:projectId/samples";
export const ROUTE_PATH_PROJECT_TRACERVISION =
    "/projects/:projectId/tracervision";
export const ROUTE_PATH_NO_PROJECTS = "/no-projects";
export const ROUTE_NOTIFICATIONS = "/account/notifications";
export const ROUTE_SURVEYS = "/account/survey";
export const ROUTE_PROFILE = "/account/profile";
export const ROUTE_PREFERENCES = "/account/preferences";
export const ROUTE_API_ACCESS = "/account/api-access";

const Routes = () => {
    return (
        <Switch>
            <ProtectedRoute exact path={ROUTE_PATH_HOME}>
                <LoginPage />
            </ProtectedRoute>

            <ProtectedRoute exact path="/comment-test">
                <CommentTestPage />
            </ProtectedRoute>

            <ProtectedRoute exact path={ROUTE_PATH_PROJECTS}>
                <UserProjectsPage />
            </ProtectedRoute>

            <ProtectedRoute exact path={ROUTE_PATH_PROJECT_OVERVIEW}>
                <ProjectOverviewPage />
            </ProtectedRoute>

            <ProtectedRoute exact path={ROUTE_PATH_PROJECT_USERS}>
                <ProjectUsersPage />
            </ProtectedRoute>

            <ProtectedRoute exact path={ROUTE_PATH_PROJECT_DOCUMENTS}>
                <ProjectDocumentsPage />
            </ProtectedRoute>

            <ProtectedRoute exact path={ROUTE_PATH_PROJECT_VIDEOS}>
                <ProjectVideosPage />
            </ProtectedRoute>

            <ProtectedRoute exact path={ROUTE_PATH_PROJECT_SAMPLES}>
                <SamplesPage />
            </ProtectedRoute>

            <ProtectedRoute exact path={ROUTE_PATH_PROJECT_TRACERVISION}>
                <TracerVisionPage />
            </ProtectedRoute>

            <ProtectedRoute exact path={ROUTE_NOTIFICATIONS}>
                <NotificationsPage />
            </ProtectedRoute>

            <ProtectedRoute exact path={ROUTE_SURVEYS}>
                <SurveyPage />
            </ProtectedRoute>

            <ProtectedRoute exact path={ROUTE_PROFILE}>
                <ProfilePage />
            </ProtectedRoute>

            <ProtectedRoute exact path={ROUTE_PREFERENCES}>
                <PreferencesPage />
            </ProtectedRoute>

            <ProtectedRoute exact path={ROUTE_PATH_NO_PROJECTS}>
                <NoProjectsPage />
            </ProtectedRoute>

            <ProtectedRoute exact path={ROUTE_API_ACCESS}>
                <ApiAccessPage />
            </ProtectedRoute>

            <Route>
                <div>Nothing to see here.</div>
            </Route>
        </Switch>
    );
};

export default Routes;
